import React from 'react'
import { useActions, useValues } from 'kea'
import PropTypes from 'prop-types'

import MenuElements from './menu-elements'

import menuLogic from './logic'

const MainMenu = ({ isLoggedIn, coursesCount, avatar, loginPath, signupPath, profilePath, firstName, mainMenuId }) => {
  const { showMenu } = useActions(menuLogic)
  const { mainMenuItems } = useValues(menuLogic)

  return (
    <div className='header-main-menu' data-attr='main-menu'>
      <div />
      <div className='global-nav-button' onClick={() => showMenu(mainMenuId)} data-attr='main-menu-link'>
        <svg width='25' height='25' viewBox='1 0 8 8'>
          <path d='M8,2 L2,2' />
          <path d='M2,4 L8,4' />
          <path d='M8,6 L2,6' />
        </svg>
      </div>
      <MenuElements
        isLoggedIn={isLoggedIn}
        coursesCount={coursesCount}
        avatar={avatar}
        loginPath={loginPath}
        signupPath={signupPath}
        profilePath={profilePath}
        firstName={firstName}
        mainMenuId={mainMenuId}
        items={mainMenuItems.filter(item => !!item)}
      />
    </div>
  )
}

MainMenu.propTypes = {
  isLoggedIn: PropTypes.bool,
  coursesCount: PropTypes.number,
  avatar: PropTypes.string,
  loginPath: PropTypes.string,
  signupPath: PropTypes.string,
  profilePath: PropTypes.string,
  firstName: PropTypes.string,
  mainMenuId: PropTypes.string
}

export default MainMenu
